import { render, staticRenderFns } from "./SongView.vue?vue&type=template&id=240de0af&scoped=true&"
import script from "./SongView.ts?vue&type=script&lang=js&"
export * from "./SongView.ts?vue&type=script&lang=js&"
import style0 from "./SongView.vue?vue&type=style&index=0&id=240de0af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240de0af",
  null
  
)

export default component.exports